<template lang='pug'>
  header.blank-header.view-header.component
</template>

<script>
  export default {
    name: 'blank-header.component'
  }
</script>

<style scoped lang='stylus'>
  .blank-header
    background var(--bg-nav)
    // height 16px
</style>
